import {
  ClickableOptionsCard,
  DirectorySettingsProvider,
  useDirectorySettingsModalProvider,
} from 'core/Components';

const DirectorySettingsAction = () => {
  const { openModalById } = useDirectorySettingsModalProvider({});
  return (
    <ClickableOptionsCard.Row title="Directory Settings" onClick={() => openModalById('base')} />
  );
};

const DirectorySettings = () => {
  return (
    <DirectorySettingsProvider>
      <DirectorySettingsAction />
    </DirectorySettingsProvider>
  );
};

export { DirectorySettings };
